export default __webpack_public_path__ + "static/Performance2-21a25879c9f1157868cad36d44a11184.gif";